<div class="navBar">
    <div class="navBar-btn">
        <button (click)="backToTransaction()"
            class="backToReport"><mat-icon>keyboard_arrow_left</mat-icon>
            <span>{{reportService.isProjectDetailOpen() ? ('User.Back'|translate) : ('reports.backToReport'|translate)}}</span> </button>
    </div>

    <div *ngIf="visibleMenuList.length > 0" class="property-detailMenu" [ngClass]="{ 'property-detailMenuAr' : currentReportView === 2}">
        <app-report-sub-menu [menuList]="visibleMenuList" [isPropertyDetailPage]="true"
            (menuChangeValue)="menuChangeValue($event)" [activeTabName] ="'property'"></app-report-sub-menu>
    </div>
</div>

<div class="report-property-detail">
    <div class="report-tabsection proj-detail-tabsection" id="{{ commonPropertyDetailMenuEnum.overview}}"
        [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.overview}">
        <app-property-details-overview [Property_Uid]="property?.property_uid" [property_cat]="property_category" [isCategoryMatch]="isCategoryMatch"
        [is_multi_parcel]="property?.is_multi_parcel"
        ></app-property-details-overview>

    </div>
</div>
 <!-- In property detail page -->
<!-- <app-municipal-regulations
  [landParcelData]="propertyLandParcelData">
</app-municipal-regulations> -->
<!-- Municipal Regulations Section -->
<ng-container *ngIf="property?.parcel_uid">
  <app-municipal-regulations
    [landParcelData]="landParceldata"
    [selectedParcelUid]="property?.parcel_uid">
  </app-municipal-regulations>
</ng-container>

<div class="report-property-detail" *ngIf="tableSection.table0 && this.property?.is_multi_parcel">
  <div class="report-tabsection proj-detail-tabsection"
       id="{{ commonPropertyDetailMenuEnum.propertyLandParcel }}"
        [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.propertyLandParcel }">
    <div class="report-model">
    <app-property-detail-land-parcels [property_uid]="property?.property_uid" [parcel_uid]="property?.parcel_uid"
    (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.propertyLandParcel)"></app-property-detail-land-parcels>

    </div>
  </div>
</div>


<!--Amenities-->
<div class="amentities detail-info  proj-detail-tabsection" id="{{ commonPropertyDetailMenuEnum.amenities}}"
        [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.amenities}"
        *ngIf="items?.length">
    <div class="info">
        <h2 class="detail-heading">{{'reports.amenities' | translate}}</h2>
        <span class="totalTransaction" *ngIf="count">({{count}})</span>
    </div>
    <div class="amenities">
        <div class="cols" *ngFor="let item of items">
           <ng-container *ngIf="item">
            <img [src]="'assets/images/amenities/'+item+'.png'" alt=""
            onerror="this.src='assets/images/amenities/ar_stickers.png'">
            <span>{{ item }}</span>
           </ng-container>
        </div>
    </div>
</div>
<!-- <ng-container *ngIf="isCategoryMatch"> -->
<div class="report-property-detail" *ngIf="tableSection.table1">
  <div class="report-tabsection proj-detail-tabsection"
       id="{{ commonPropertyDetailMenuEnum.PropertylandPriceTable }}"
       [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertylandPriceTable }">
    <div class="report-model">
    <app-property-land-price-details-table
        [property_uid]="property?.property_uid"
        (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertylandPriceTable)">
    </app-property-land-price-details-table>
    </div>
  </div>
</div>
<!-- </ng-container> -->

<!-- Land Price Analysis (Comparable Lands Within Same Project) -->
 <!-- <ng-container *ngIf="isCategoryMatch"> -->
<div *ngIf="isMultiPropInProject && this.chartsection.chart1">
    <div class="report-model">
        <app-land-price-analysis-chart [title]="'reports.Land_Price_Analysis'" [Property_Uid]="property?.property_uid"
            [chartId]="'linechart_'+commonPropertyDetailMenuEnum.landPricesProject"
            [type]="'project'"
            (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.landPricesProject)">
        </app-land-price-analysis-chart>
    </div>
</div>
<!-- Land Price Analysis (Comparable Lands Within Neighborhood) -->
<div   *ngIf="!isMultiPropInProject && this.chartsection.chart1">
    <div class="report-model">
        <app-land-price-analysis-chart [title]="'reports.Land_Price_Analysis_neighborhood'"
            [Property_Uid]="property?.property_uid"
            [chartId]="'linechart_'+commonPropertyDetailMenuEnum.landPricesProject"
            [type]="'neighborhood'"
            (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.landPricesProject)">
        </app-land-price-analysis-chart>
    </div>
</div>
<!-- </ng-container> -->


    <!-- Property price -->
    <!-- <ng-container *ngIf="isCategoryMatch"> -->
    <div class="report-property-detail" *ngIf="tableSection.table2">
        <div class="report-tabsection proj-detail-tabsection"
        id="{{ commonPropertyDetailMenuEnum.PropertyPrices}}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyPrices}">
            <div class="report-model">
                <app-property-price-details-table
                    [property_uid]="property?.property_uid"
                    (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyPrices)">
                </app-property-price-details-table>
            </div>
        </div>
    </div>
    <!-- </ng-container> -->
    <!-- <ng-container *ngIf="this.property?.property_category?.toLowerCase().includes(propertyCategoryEnum.VillaHouse)">
        <ng-container *ngIf="isCategoryMatch"> -->
        <!-- Villa price analysis chart -->
        <div *ngIf="isMultiPropInProject && this.chartsection.chart2">
            <div class="report-model">
                <app-villa-price-analysis-chart [title]="'reports.Villa_Price_Analysis'"
                    [Property_Uid]="property?.property_uid"
                    [chartId]="'linechart_'+commonPropertyDetailMenuEnum.VillaPriceAnalysis"
                    [type]="'project'"
                    (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.VillaPriceAnalysis)">
                </app-villa-price-analysis-chart>
            </div>
        </div>
        <div *ngIf="!isMultiPropInProject && this.chartsection.chart2">
            <div class="report-model">
                <app-villa-price-analysis-chart [title]="'reports.Villa_Price_Analysis_neighborhood'"
                    [Property_Uid]="property?.property_uid"
                    [chartId]="'linechart_'+commonPropertyDetailMenuEnum.VillaPriceAnalysis"
                    [type]="'neighborhood'"
                    (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.VillaPriceAnalysis)">
                </app-villa-price-analysis-chart>
            </div>
        </div>

    <!-- </ng-container> -->
    <!-- Villa price analysis chart -->
<!-- </ng-container> -->


<!-- <ng-container *ngIf="this.property?.property_category?.toLowerCase().includes(propertyCategoryEnum.MultiStoryResidential)"> -->
  <div class="report-property-detail" *ngIf="tableSection.table9">
    <div class="report-tabsection proj-detail-tabsection" id="{{ commonPropertyDetailMenuEnum.ResidentialUnits}}"
        [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.ResidentialUnits}">
        <app-residential-units [propertyInfo]="property" (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.ResidentialUnits)"></app-residential-units>
    </div>
  </div>
<!-- </ng-container> -->

<!-- Property unit Prices -->
 <!-- <ng-container *ngIf="isCategoryMatch && property_category !== propertyCategoryEnum.VillaHouse"> -->
  <!-- <ng-container *ngIf=" property_category !== propertyCategoryEnum.VillaHouse"> -->
 <!-- <ng-container *ngIf="(isCategoryMatch || isAllTransactions) && property_category !== propertyCategoryEnum.VillaHouse"> -->
<div class="report-property-detail" *ngIf="tableSection.table3">
    <div class="report-tabsection proj-detail-tabsection"
        id="{{ commonPropertyDetailMenuEnum.PropertyunitPrices}}"
        [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyunitPrices}">
        <div class="report-model">
            <app-property-unit-price-details-table
                [property_uid]="property?.property_uid"
                (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyunitPrices)">
            </app-property-unit-price-details-table>

        </div>
    </div>
</div>
<!-- </ng-container> -->


<!-- <ng-container *ngIf="this.property?.property_category?.toLowerCase().includes(propertyCategoryEnum.MultiStoryResidential)">
    <ng-container *ngIf="isCategoryMatch"> -->
    <!-- Apartment Price Analysis -->
    <div *ngIf="this.chartsection.chart3">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.apartmentPriceAnalysis'"
                [Property_Uid]="property?.property_uid"
                [type]="'apartment'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.apartmentPriceAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailApartmentResidentialPriceAnalysis"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.apartmentPriceAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>
    <!-- </ng-container>
 </ng-container> -->
 <!-- <ng-container *ngIf="this.property?.property_category?.toLowerCase().includes(propertyCategoryEnum.MultiStoryResidential)">
    <ng-container *ngIf="isCategoryMatch"> -->
    <!-- Residential Rental -->
    <div class="report-property-detail" *ngIf="tableSection.table4">
        <div class="report-tabsection proj-detail-tabsection"
        id="{{ commonPropertyDetailMenuEnum.PropertyResidentialRental}}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyResidentialRental}">
            <div class="report-model">
            <app-datatable-title [title]="'reports.ResidentialRental'" [isShowCount]="false"></app-datatable-title>
                <app-residential-rental-details-table
                    [property_uid]="property?.property_uid"
                    (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyResidentialRental)">
                </app-residential-rental-details-table>

            </div>
        </div>
    </div>
    <!-- </ng-container> -->

    <!-- Residential Rental Analysis -->
     <!-- <ng-container *ngIf="isCategoryMatch"> -->
    <div *ngIf="this.chartsection.chart4">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.residentialAnalysis'"
                [Property_Uid]="property?.property_uid"
                [type]="'residential'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.residentialAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailApartmentResidentialPriceAnalysis"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.residentialAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>
    <!-- </ng-container>
</ng-container> -->

<!-- <ng-container *ngIf="isCategoryMatch && property_category == propertyCategoryEnum.RetailFbAndEntertainment"> -->

    <div class="report-property-detail" *ngIf="tableSection.table5">
        <div class="report-tabsection proj-detail-tabsection"
            id="{{ commonPropertyDetailMenuEnum.PropertyRetailRental}}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyRetailRental}">
            <div class="report-model">
                <app-datatable-title [title]="'reports.RetailRental'" [isShowCount]="false"></app-datatable-title>
                <app-retail-rental-details-table
                    [property_uid]="property?.property_uid"
                    (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyRetailRental)">
                    </app-retail-rental-details-table>
            </div>
        </div>
    </div>


    <!-- Retail Rental Analysis -->
    <div *ngIf="isMultiPropInProject && this.chartsection.chart5">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Retail_Rental_Analysis_Within_Project'"
                [Property_Uid]="property?.property_uid"
                [type]="'project'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.retailAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailRetailRentalAnalysisPropertyProject"
                [project_name]="property?.project_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.retailAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>

    <div *ngIf="!isMultiPropInProject && this.chartsection.chart5">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Retail_Rental_Analysis_Within'"
                [Property_Uid]="property?.property_uid"
                [type]="'neighborhood'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.retailAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailRetailRentalAnalysisPropertyProject"
                [neigh_name]="property?.neigh_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.retailAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>
    <!-- Retail Rental Analysis -->

    <div class="report-property-detail" *ngIf="tableSection.table6">
        <div class="report-tabsection proj-detail-tabsection"
            id="{{ commonPropertyDetailMenuEnum.PropertyOfficeRental }}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyOfficeRental }">
            <div class="report-model">
            <app-datatable-title [title]="'reports.OfficeRental'" [isShowCount]="false"></app-datatable-title>

            <app-office-rental-details-table
                [property_uid]="property?.property_uid"
                (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyOfficeRental)">
            </app-office-rental-details-table>
            </div>
        </div>
    </div>

    <!-- Office Rental Analysis  -->
    <div *ngIf="isMultiPropInProject && this.chartsection.chart6">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Office_Rental_Analysis_Within_Project'"
                [Property_Uid]="property?.property_uid"
                [type]="'project'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.officeAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailOfficeRentalAnalysisPropertyProject"
                [project_name]="property?.project_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.officeAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>

    <div *ngIf="!isMultiPropInProject && this.chartsection.chart6">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Office_Rental_Analysis_Within'"
                [Property_Uid]="property?.property_uid"
                [type]="'neighborhood'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.officeAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailOfficeRentalAnalysisPropertyProject"
                [neigh_name]="property?.neigh_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.officeAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>
<!-- Office Rental Analysis  -->

<!-- </ng-container> -->


<!-- <ng-container *ngIf="isCategoryMatch && property_category == propertyCategoryEnum.MultiStoryOffice">

    <div class="report-property-detail" *ngIf="tableSection.table6">
        <div class="report-tabsection proj-detail-tabsection"
            id="{{ commonPropertyDetailMenuEnum.PropertyOfficeRental }}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyOfficeRental }">
            <div class="report-model">
            <app-datatable-title [title]="'reports.OfficeRental'" [isShowCount]="false"></app-datatable-title>

            <app-office-rental-details-table
                [property_uid]="property?.property_uid"
                (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyOfficeRental)">
            </app-office-rental-details-table>
            </div>
        </div>
    </div>

    <div *ngIf="isMultiPropInProject && this.chartsection.chart6">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Office_Rental_Analysis_Within_Project'"
                [Property_Uid]="property?.property_uid"
                [type]="'project'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.officeAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailOfficeRentalAnalysisPropertyProject"
                [project_name]="property?.project_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.officeAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>

    <div *ngIf="!isMultiPropInProject && this.chartsection.chart6">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Office_Rental_Analysis_Within'"
                [Property_Uid]="property?.property_uid"
                [type]="'neighborhood'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.officeAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailOfficeRentalAnalysisPropertyProject"
                [neigh_name]="property?.neigh_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.officeAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>

    <div class="report-property-detail" *ngIf="tableSection.table5">
        <div class="report-tabsection proj-detail-tabsection"
            id="{{ commonPropertyDetailMenuEnum.PropertyRetailRental}}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyRetailRental}">
            <div class="report-model">
                <app-datatable-title [title]="'reports.RetailRental'" [isShowCount]="false"></app-datatable-title>
                <app-retail-rental-details-table
                    [property_uid]="property?.property_uid"
                    (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyRetailRental)">
                    </app-retail-rental-details-table>
            </div>
        </div>
    </div>


    <div *ngIf="isMultiPropInProject && this.chartsection.chart5">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Retail_Rental_Analysis_Within_Project'"
                [Property_Uid]="property?.property_uid"
                [type]="'project'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.retailAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailRetailRentalAnalysisPropertyProject"
                [project_name]="property?.project_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.retailAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>

    <div *ngIf="!isMultiPropInProject && this.chartsection.chart5">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Retail_Rental_Analysis_Within'"
                [Property_Uid]="property?.property_uid"
                [type]="'neighborhood'"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.retailAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailRetailRentalAnalysisPropertyProject"
                [neigh_name]="property?.neigh_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.retailAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>


</ng-container> -->


<!-- <ng-container *ngIf="this.property?.property_category?.toLowerCase().includes(propertyCategoryEnum.IndustryWorkshopWarehouse)">
    <ng-container *ngIf="isCategoryMatch"> -->
    <div class="report-property-detail" *ngIf="tableSection.table7">
        <div class="report-tabsection proj-detail-tabsection"
        id="{{ commonPropertyDetailMenuEnum.PropertyWarehouseRental}}"
            [ngClass]="{ 'scroll': currentScroll === commonPropertyDetailMenuEnum.PropertyWarehouseRental}">
            <div class="report-model">
                <app-datatable-title [title]="'reports.WarehouseRental'"[isShowCount]="false"></app-datatable-title>
            <app-warehouse-rental-details-table
            [property_uid]="property?.property_uid"
            (isEmpatyCheck)="updateSectionFromChild($event,commonPropertyDetailMenuEnum.PropertyWarehouseRental)">
        </app-warehouse-rental-details-table>
            </div>
        </div>
    </div>
    <!-- </ng-container> -->

    <!-- Warehouse Rental Analysis Within Dasma Neighborhood -->
     <!-- <ng-container *ngIf="isCategoryMatch"> -->
    <div *ngIf="this.chartsection.chart7">
        <div class="report-model">
            <app-land-price-comparable-chart [chartTitle]="'reports.Warehouse_Rental_Analysis_Within'"
                [Property_Uid]="property?.property_uid"
                [type]="''"
                [SectionId]="'linechart_'+commonPropertyDetailMenuEnum.warehouseAnalysis"
                [ApiEndPoint]="apiEndPoints.propertyDetailwarehouseRentalAnalysis"
                [neigh_name]="property?.neigh_name"
                (isEmpatyCheck)="updateSection($event, commonPropertyDetailMenuEnum.warehouseAnalysis)">
            </app-land-price-comparable-chart>
        </div>
    </div>
    <!-- </ng-container>
</ng-container> -->
